
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  layout: 'minimal',
  name: `AccountSigninPage`,
  data() {
    return {
      provider: 'spendgo',
    }
  },
  head() {
    return this.$utils.head(this.story)
  },
  async asyncData({ $utils }) {
    return {
      story: await $utils.content('account/signin')
    }
  },
  beforeRouteUpdate(to, from, next) {
    // Your code here
    console.log(to);
    console.log('Before route update');

    // If you want to proceed with the route change, call next()
    next();
  },
  computed: {
    ...mapState([ 'appState', 'deviceId' ]),
  },
  async mounted() {
    await this.getAppState(this.$route)
    this.setAppState({
      client_type: 'web',
    })
    localStorage.setItem('leesfamousrecipe_borderless_client_type', 'web')

    // Redirect to SSO
    const redirect = await this.sendRequest({
      method: 'get',
      headers: {
        client_type: 'web'
      },
      url: 'members/auth',
      params: {
        redirect_uri: process.env.SPENDGO_REDIRECT_URI,
        code: true
      }
    }).then(res => {
      console.log("Sign In Response", res)
      return res.data.url + '&hide_header=true' // add querystring param to hide the header in the olo sign in/up window
    }).catch(err => {
      return null
    })
    if(redirect) {
      console.log("Redirect Response", redirect)
      window.location = redirect
      return false
    } else {
      this.$router.push('/')
      return false
    }
  },
  computed: { },
  methods: {
    ...mapMutations([ 'setAppState' ]),
    ...mapActions([ 'sendRequest', 'getAppState' ]),
  }
}
